export default __webpack_public_path__ + "static/media/ic-more.91f734ea.svg";